import React from 'react';
import FlosField, { FlosFieldProps } from '../../flos-field';
import { SelectInput, SelectInputProps } from './custom-select-input';

export type SelectFieldProps = SelectInputProps & Omit<FlosFieldProps, 'custom' | 'pattern' | 'maxLength' | 'minLength' | 'showLength' | 'isOpen' | 'editable'>;

/**
 * `SelectField` is a composition of `FlosField` component and `SelectInput` components. If you need extra customization, you can compose them yourself.
 */
export const SelectField = React.forwardRef<HTMLSelectElement, SelectFieldProps>(
    ({ isValid, onValidityChange, errorText = 'skal udfyldes', wrapperClassName, helpText, ...selectProps }: any, ref) => {
        return (
            <FlosField
                ref={ref}
                isValid={isValid}
                onValidityChange={onValidityChange}
                label={selectProps.label}
                errorText={errorText}
                required={selectProps.required}
                id={selectProps.id}
                hasDropdown={true}
                wrapperClassName={wrapperClassName}
                disabled={selectProps.disabled}
                helpText={helpText}
                iconShape={selectProps.iconShape}
                renderInput={({ getInputProps }) => <SelectInput {...getInputProps({ ...selectProps })} />}
                data-testid={selectProps['data-testid']}
            />
        );
    }
);
